var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowFill = function SvgShowFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 405.333a106.667 106.667 0 1 1 0 213.334 106.667 106.667 0 0 1 0-213.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 170.667a323.07 323.07 0 0 1 232.32 98.56L981.333 512 744.32 754.773A322.99 322.99 0 0 1 512 853.333a322.99 322.99 0 0 1-232.32-98.56L42.667 512 279.68 269.227A323.2 323.2 0 0 1 512 170.667m0 128a213.333 213.333 0 1 0 .043 426.666A213.333 213.333 0 0 0 512 298.667"
  })));
};
export default SvgShowFill;